import React, { useState } from "react"
import {graphql, useStaticQuery} from "gatsby"

import epaStyles from './epa_tiers.module.scss'
import { VictoryAxis, VictoryChart, VictoryLabel, VictoryLine, VictoryScatter } from "victory"
import ScatterImage from "../helper_js/scatter_image"
import Select from "react-select"

const EpaTiers = () => {
    const data = useStaticQuery(graphql`
        query {
            allEpaTierLinesJson {
                nodes {
                    season
                    line_type
                    x
                    y
                    labels
                    label_angle
                    off_median
                    def_median
                    x_min
                    x_max
                    y_min
                    y_max
                }
            }
            allTeamsCsv {
                nodes {
                    season
                    team
                    epa_per_play_ytd
                    epa_per_play_against_ytd
                    team_nick
                    team_logo_espn
                    team_color
                    team_color2
                }
            }
            justYears: allEpaTierLinesJson {
                distinct (
                    field: season
                )
            }
        }
    `)

    // $site_grey: #525252;
    const reduce_grey = '#b8b8b8'
    // $very_reduce_grey: #f5f5f5;
    const highlight_red = '#ff4a77'
    // $highlight_blue: #4a92ff;

    const dropOptions = data.justYears.distinct.map((node) => {
        return(
            {'value' : parseInt(node), 'label' : parseInt(node)}
        )
    })

    const [selectedSeason, setSelectedSeason] = useState(dropOptions[dropOptions.length-1])

    return (
        <div className={epaStyles.containerWrapper}>
            <h2 className={epaStyles.section_header}>
                About EPA Tiers
            </h2>
            <div className={epaStyles.about_div}>
                <p className={epaStyles.about_text}>
                    EPA tiers plot teams by their offensive (x-axis) and defensive (y-axis) performance as measured by EPA / Play.
                </p>
                <p className={epaStyles.about_text}>
                    The grey tier lines create comparisons across teams. Teams on the same line are "equal" and expected to perform similarly on a forward looking basis. Because offensive performance is more predictive than defensive performance, these lines have a slope greater than 1 (1.6).
                </p>
                <p className={epaStyles.about_text}>
                    The tiers themselves represent the historical distribution of teams against the league average (median). For instance, a team at the "p90" line would be better than 90% of teams in any given year.
                </p>
            </div>
            <div className={epaStyles.spacer_div}></div>
            <div className={epaStyles.containerDiv}>
                <div className={epaStyles.selectContainerDiv}>
                    <Select
                        options={dropOptions}
                        onChange={setSelectedSeason}
                        placeholder='Select Season'
                    />
                </div>
                <div className={epaStyles.chartContainerDiv}>
                    <VictoryChart
                            domainPadding={{
                                y:[0,0],
                                x:[0,0]
                            }}
                            width={550}
                            height={400}
                        >
                            <VictoryAxis
                                label='Offensive EPA / Play'
                                style={{
                                    axisLabel: {
                                        fontSize: '10px',
                                        padding: '30',
                                        fontWeight: "bold"
                                    },
                                    tickLabels: {
                                        fontSize: '8px',
                                        color: '#808080',
                                    },
                                }}
                                orientation='bottom'
                                offsetY={50}
                            />
                            <VictoryAxis
                                dependentAxis
                                label='Defensive EPA / Play'
                                style={{
                                    axisLabel: {
                                        fontSize: '10px',
                                        padding: '40',
                                        fontWeight: "bold"
                                    },
                                    tickLabels: {
                                        fontSize: '8px',
                                        color: '#808080',
                                    },
                                }}
                                offsetX={50}
                            />
                            {data.allEpaTierLinesJson.nodes.map((node) => {
                                if (parseInt(node['season']) === selectedSeason['value']) {
                                    const victoryData = [
                                        {x: node['x'][0], y: node['y'][0], label: node['labels'][0]},
                                        {x: node['x'][1], y: node['y'][1], label: node['labels'][1]},
                                        {x: node['x'][2], y: node['y'][2], label: node['labels'][2]},
                                    ]
                                    return(
                                        <VictoryLine
                                            data={victoryData}
                                            x='x'
                                            y='y'
                                            labels='label'
                                            style={{
                                                data: {
                                                    stroke: reduce_grey,
                                                    strokeWidth: 1,
                                                },
                                            }}
                                            labelComponent={
                                                <VictoryLabel
                                                    angle={node['label_angle']+14.75}
                                                    dx={0}
                                                    dy={5}
                                                    textAnchor={'start'}
                                                    verticalAnchor={'middle'}
                                                    style={{
                                                        fill: reduce_grey,
                                                        fontSize: 10,
                                                    }}
                                                />
                                            }
                                        />
                                    )
                                } else {
                                    return(null)
                                }
                            })}
                            {data.allEpaTierLinesJson.nodes.map((node) => {
                                if (parseInt(node['season']) === selectedSeason['value']) {
                                    const victoryData = [
                                        {x: node['x_min'], y: node['def_median'],},
                                        {x: node['x_max'], y: node['def_median'],},
                                    ]
                                    console.log(victoryData)
                                    return(
                                        <VictoryLine
                                            data={victoryData}
                                            x='x'
                                            y='y'
                                            style={{
                                                data: {
                                                    stroke: highlight_red,
                                                    strokeWidth: 1.5,
                                                    strokeDasharray: '5,5',
                                                    strokeOpacity: .05,
                                                },
                                            }}
                                        />
                                    )
                                } else {
                                    return(null)
                                }
                            })}
                            {data.allEpaTierLinesJson.nodes.map((node) => {
                                if (parseInt(node['season']) === selectedSeason['value']) {
                                    const victoryData = [
                                        {x: node['off_median'], y: node['y_min'],},
                                        {x: node['off_median'], y: node['y_max'],},
                                    ]
                                    return(
                                        <VictoryLine
                                            data={victoryData}
                                            x='x'
                                            y='y'
                                            style={{
                                                data: {
                                                    stroke: highlight_red,
                                                    strokeWidth: 1.5,
                                                    strokeDasharray: '5,5',
                                                    strokeOpacity: .05,
                                                },
                                            }}
                                        />
                                    )
                                } else {
                                    return(null)
                                }
                            })}
                            {data.allTeamsCsv.nodes.map((node) => {
                                if (parseInt(node['season']) === selectedSeason['value']) {
                                    const victoryData = [
                                        {
                                            x: Math.round(10000*node['epa_per_play_ytd'])/10000,
                                            y: Math.round(-10000*node['epa_per_play_against_ytd'])/10000,
                                        }
                                    ]
                                    return(
                                        <VictoryScatter
                                            dataComponent={
                                                <ScatterImage
                                                    logoUrl={node.team_logo_espn}
                                                    team={node.team}
                                                    season={node.season}
                                                    includeSeason={false}
                                                />
                                            }
                                            data={victoryData}
                                            x='x'
                                            y='y'
                                        />
                                    )
                                } else {
                                    return(null)
                                }
                            })}
                        </VictoryChart>
                    </div>
            </div>
        </div>
    )

}

export default EpaTiers